import { render, staticRenderFns } from "./CertificadoMantencion.vue?vue&type=template&id=52a13c1e&"
import script from "./CertificadoMantencion.vue?vue&type=script&lang=js&"
export * from "./CertificadoMantencion.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoMantencion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports